import {
    REPORTS_EXPORT_HISTORY_REQUEST,
    REPORTS_EXPORT_HISTORY_RESULT,
    REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_REQUEST,
    REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_RESULT,
} from 'Redux/actionTypes';

export const reportsExportHistoryRequest = (data) => ({
    type: REPORTS_EXPORT_HISTORY_REQUEST,
    payload: data
})

export const reportsExportHistoryResult = (result) => ({
    type: REPORTS_EXPORT_HISTORY_RESULT,
    payload: result
})

export const reportsExportHistoryRefreshExportLogUrlRequest = (data) => ({
    type: REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_REQUEST,
    payload: data
})

export const reportsExportHistoryRefreshExportLogUrlResult = (result) => ({
    type: REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_RESULT,
    payload: result
})
